import StickyHeadroom from '@integreat-app/react-sticky-headroom';

interface StickyHeaderProps {
  children?: React.ReactNode;
  stickyHeaderHeight: number;
  onStickyTopChanged: (stickyTop: number) => void;
}

export const StickyHeader: React.FC<StickyHeaderProps> = ({
  stickyHeaderHeight,
  onStickyTopChanged,
  children,
}) => {
  return (
    <StickyHeadroom
      pinStart={stickyHeaderHeight}
      height={stickyHeaderHeight}
      scrollHeight={0}
      onStickyTopChanged={onStickyTopChanged}
    >
      <div>{children}</div>
    </StickyHeadroom>
  );
};
